import { render, staticRenderFns } from "./category-panel.vue?vue&type=template&id=5123b802&scoped=true"
import script from "./category-panel.vue?vue&type=script&lang=js"
export * from "./category-panel.vue?vue&type=script&lang=js"
import style0 from "./category-panel.vue?vue&type=style&index=0&id=5123b802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123b802",
  null
  
)

export default component.exports